import axios from "axios";

import { getAuth } from "firebase/auth";
import { getEnvVariable } from "../../env.utils";

const auth = getAuth();

// Environment-based configuration
export const config = {
  development: {
    baseURL: getEnvVariable("VITE_HOST"),
  },
  production: {
    baseURL: getEnvVariable("VITE_HOST") ?? "https://belluai.com",
  },
};

// Determine the current environment
export const environment = import.meta.env.VITE_MODE as
  | "development"
  | "production";

// Create an axios instance with the base configuration
export const apiClient = axios.create({
  baseURL: config[environment].baseURL,
});
apiClient.interceptors.request.use(
  async (config) => {
    const user = auth.currentUser;

    if (user) {
      const idToken = await user.getIdToken();
      config.headers["Authorization"] = `Bearer ${idToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);
